import { useStaticQuery, graphql } from "gatsby"
import { first } from "utils/lodashExtracts";
import T from "types/index";

const query = () : T.Charles.BlogCtaDataRecord[] => {
  const { allAirtableBlogCtas: { nodes } } = useStaticQuery(graphql`
    query {
      allAirtableBlogCtas {
        nodes {
          id
          data {
            bloc_code
            bloc_title
            bloc_cta_label
            cta_url
            sticky_banner_title
            sticky_banner_cta_label
            sticky_banner_content { ...AirtableMarkdownFields }
            bloc_cta_bullets { ...AirtableMarkdownFields }
            image { ...AirtableImagesConstrainedFields }
            heading_bloc_title
            heading_bloc_cta_label
          }
        }
      }
    }
  `);
  return nodes
}

const blockCodeToCode = (blockCode: string): (string | undefined) => {

  const match = /"(.*?)"/.exec(blockCode)
  const ctaCode = match ? match[1] : undefined
  return ctaCode
}

export const useAirtableBlogCta = (post: T.Blog.Post): (T.Charles.BlogCtaDataRecord | undefined)=> {
  const records = query()

  const ctaBlocks = post.blocks
      ? post.blocks.filter((block: any) => block.name === "core/shortcode")
      : [];
  const firstCtaBlock = first(ctaBlocks.map((block: any) => block.attributes.text))
  const defaultValue = 'blog-post-consultation-block'
  const ctaCode = blockCodeToCode(firstCtaBlock) || defaultValue
  const matchingRecord = records.find((record: T.Charles.BlogCtaDataRecord) => record.data.bloc_code === ctaCode)
  const defaultRecord = records.find((record: T.Charles.BlogCtaDataRecord) => record.data.bloc_code === defaultValue)

  return matchingRecord || defaultRecord || undefined
}

export const useAirtableBlogCtaByBlockCode = (blockCode: string): (T.Charles.BlogCtaDataRecord | undefined)=> {
  const records = query()

  const ctaCode = blockCodeToCode(blockCode)
  const matchingRecord = records.find((record: T.Charles.BlogCtaDataRecord) => record.data.bloc_code === ctaCode)

  return matchingRecord || undefined
}
